<template>
  <p class="clearfix mb-0 px-3 py-2 text-center text-md-left">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      © {{ new Date().getFullYear() }}
      <b-link
        class="ml-25"
        href="#"
        target="_blank"
      >TojTel</b-link>,
      <br class="d-block d-md-none">
      <span class="">Все права защищены.</span>
    </span>

    <span class="float-md-right d-block d-md-inline-block ">
      <span class="d-block d-md-inline-block" >Онлайн магазин номеров и пакетов. </span> <span class="d-block d-md-inline-block"> Разработка: <a href="https://azizon.cc" target="_blank"> Azizon CC</a></span>
    </span>
  </p>
</template>

<script>
import { BLink } from 'bootstrap-vue'

export default {
  components: {
    BLink,
  },
}
</script>
